var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.615 1.15418L29.115 14.6542C29.655 15.1942 30 15.9592 30 16.7842C30 17.6092 29.67 18.3592 29.115 18.8992L18.615 29.3992C18.075 29.9542 17.325 30.2842 16.5 30.2842C15.675 30.2842 14.925 29.9542 14.385 29.4142L0.885 15.9142C0.33 15.3592 0 14.6092 0 13.7842V3.28418C0 1.63418 1.35 0.28418 3 0.28418H13.5C14.325 0.28418 15.075 0.61418 15.615 1.15418ZM3 5.53418C3 6.77918 4.005 7.78418 5.25 7.78418C6.495 7.78418 7.5 6.77918 7.5 5.53418C7.5 4.28918 6.495 3.28418 5.25 3.28418C4.005 3.28418 3 4.28918 3 5.53418Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOffer);
export default __webpack_public_path__ + "static/media/local-offer.f97e2ff0.svg";
export { ForwardRef as ReactComponent };